// Vue
import { ref } from 'vue'

// Offline
import { enableDebug, disableDebug } from '../logger'

/**
 * qaMode — modo diagnóstico activable EN RUNTIME, sin consola ni env de build.
 *
 * El APK lo genera un tercero que no tiene nuestro .env, así que la activación no puede depender de
 * OFFLINE_DEBUG: QA lo enciende DENTRO de la app (5 taps en la versión del sidebar). Comparte la
 * misma llave localStorage del logger ('offline_v2_debug'): encenderlo aquí pone el logger verbose
 * al instante (enableDebug) y sobrevive reinicios (el logger la lee en el boot). El ref es a nivel
 * módulo: el banner de sync reacciona al toggle sin importar desde qué componente se disparó.
 */

const KEY = 'offline_v2_debug'

function readStored () {
  try { return window.localStorage.getItem(KEY) === '1' } catch { return false }
}

const active = ref(readStored())

export function useQaMode () {
  function enable () {
    enableDebug()
    active.value = true
  }
  function disable () {
    disableDebug()
    active.value = false
  }
  /** Devuelve el estado resultante para que el caller notifique al usuario. */
  function toggle () {
    if (active.value) disable()
    else enable()
    return active.value
  }
  return { qaMode: active, enable, disable, toggle }
}
